import { render, staticRenderFns } from "./ProductColorsList.vue?vue&type=template&id=7fd28b6f&"
import script from "./ProductColorsList.vue?vue&type=script&lang=js&"
export * from "./ProductColorsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductColorsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports